/* Parwin free-gift.
   - Adds exactly ONE free gift when a qualifying product is added.
   - Never adds on removals/changes (so deleting an item just deletes, no re-add loop).
   - Removes the gift if no qualifying product remains; caps the gift at qty 1.
   - Synchronous lock + debounce so a single add can never create duplicate gifts.
   Gift is £0 via the store's automatic "buy a dryer/straightener, get gift free" discount. */
(function () {
  var CFG = window.PP_GIFT || {};
  var GIFT = Number(CFG.giftVariantId);
  var ELIG = (CFG.eligibleIds || []).map(Number); // product ids
  if (!GIFT) return;
  var origFetch = window.fetch.bind(window);
  var locked = false, timer = null, wantAdd = false, dirty = false;

  function getCart() { return origFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      var s = el.dataset && el.dataset.sectionId;
      if (s && ids.indexOf(s) === -1) ids.push(s);
    });
    return ids;
  }
  function mutate(url, body) {
    var ids = sectionIds();
    if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
    return origFetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function refreshDrawer(resp) {
    if (!resp || !resp.sections) return;
    getCart().then(function (cart) {
      try {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'pp-free-gift', data: { source: 'pp-free-gift', itemCount: cart.item_count, sections: resp.sections } } }));
      } catch (e) {}
    });
  }
  function hasQual(cart) { return cart.items.some(function (i) { return ELIG.indexOf(i.product_id) > -1; }); }
  function giftLine(cart) { return cart.items.filter(function (i) { return i.variant_id === GIFT; })[0]; }

  function finish(resp) { locked = false; if (resp) refreshDrawer(resp); if (dirty) { dirty = false; schedule(false); } }

  function reconcile(allowAdd) {
    if (locked) { dirty = true; return; }
    locked = true;
    getCart().then(function (cart) {
      var g = giftLine(cart), qual = hasQual(cart);
      if (g && g.quantity > 1) return mutate('/cart/change.js', { id: String(GIFT), quantity: 1 }).then(finish); // cap to one
      if (g && !qual)          return mutate('/cart/change.js', { id: String(GIFT), quantity: 0 }).then(finish); // orphan -> remove
      if (!g && qual && allowAdd) return mutate('/cart/add.js', { items: [{ id: GIFT, quantity: 1, properties: { _free_gift: 'true' } }] }).then(finish); // add one, only on product-add
      finish(null); // already correct
    }).catch(function () { finish(null); });
  }
  function run() { var a = wantAdd; wantAdd = false; reconcile(a); }
  function schedule(isAdd) {
    if (isAdd) wantAdd = true;
    if (locked) { dirty = true; return; }
    clearTimeout(timer); timer = setTimeout(run, 300);
  }

  // Only react to cart mutations the THEME makes. Our own calls use origFetch, so they don't re-trigger.
  window.fetch = function () {
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var p = origFetch.apply(null, arguments);
    if (typeof url === 'string' && url.indexOf('cart.js') === -1) {
      if (/\/cart\/add/.test(url)) p.then(function () { schedule(true); }).catch(function () {});
      else if (/\/cart\/(change|update|clear)/.test(url)) p.then(function () { schedule(false); }).catch(function () {});
    }
    return p;
  };
  // On load: cleanup only (cap/remove orphan), never auto-add.
  if (document.readyState !== 'loading') reconcile(false);
  else document.addEventListener('DOMContentLoaded', function () { reconcile(false); });

  // The "free gift" note under the button acts as an add-to-cart trigger.
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-pp-addcart]');
    if (!t) return;
    e.preventDefault();
    var scope = t.closest('.shopify-section') || document;
    var btn = scope.querySelector('form.shopify-product-form button[name="add"]') ||
              document.querySelector('form.shopify-product-form button[name="add"]') ||
              scope.querySelector('.add-to-cart-button');
    if (btn) btn.click();
  });

  // "Free gift" badge on eligible product cards (home / category / recommendations),
  // in the sale-badge container, same height, same line.
  function addGiftBadges() {
    if (!ELIG.length) return;
    document.querySelectorAll('product-card[data-product-id]').forEach(function (card) {
      if (ELIG.indexOf(Number(card.dataset.productId)) === -1) return;
      if (card.querySelector('.pp-giftbadge')) return;
      var container = card.querySelector('.product-badges--top-left');
      if (!container) {
        var gallery = card.querySelector('[ref="cardGallery"], .card-gallery');
        if (!gallery) return;
        container = document.createElement('div');
        container.className = 'product-badges product-badges--top-left';
        gallery.appendChild(container);
      }
      var b = document.createElement('div');
      b.className = 'product-badges__badge product-badges__badge--rectangle pp-giftbadge';
      b.textContent = '🎁 Free gift';
      container.appendChild(b);
    });
  }
  var _badgeT;
  function scheduleBadges() { clearTimeout(_badgeT); _badgeT = setTimeout(addGiftBadges, 120); }
  if (document.readyState !== 'loading') addGiftBadges();
  else document.addEventListener('DOMContentLoaded', addGiftBadges);
  try { new MutationObserver(scheduleBadges).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
